import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const PUBLIC_OPTIONS = [
  { value: 'true', label: 'True', limit: 1 },
  { value: 'false', label: 'False', limit: 1 },
];

export const publicDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.PUBLIC,
    name: 'Public',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
